import React from 'react';

const getPercentageRingColor = (percentage) => {
    if (percentage >= 75) return '#28a745';
    if (percentage >= 50) return '#ffc107';
    return '#dc3545';
};

const ContactPercentageRing = ({ percentage }) => {
    const value = Math.max(0, Math.min(100, Number(percentage) || 0));

    return (
        <div
            className="contactsCorePercentageRing"
            style={{
                '--contacts-core-percentage': `${value}%`,
                '--contacts-core-ring-color': getPercentageRingColor(value)
            }}
        >
            <div className="contactsCorePercentageRingInner">
                <h3 className="m-0">{value}%</h3>
            </div>
        </div>
    );
};

export default ContactPercentageRing;
